// extracted by mini-css-extract-plugin
module.exports =  {"branding-level-wrapper":"_0bc5e8de02--branding-level-wrapper--yor80","platinum":"_0bc5e8de02--platinum--U46Y5"};